export default __webpack_public_path__ + "static/media/servicio-reductivo.2d5b9351.jpg";